import React, { useEffect, useState } from 'react';
import { useCliente } from '../../../navigation/context/ClienteContext';
import { EstruturaOrganizacionalListaService } from '../PortalTransparenciaPage/utils/useServices';
import CollapsibleList from '../CollapsibleList';

export default function EstruturaOrganizacional() {
  const { identificador } = useCliente();
  const [estruturaOrganizacional, setEstruturaOrganizacional] = useState([]);

  useEffect(() => {
    if (identificador) {
      const fetchEstruturaOrganizacional = async () => {
        const { data } = await EstruturaOrganizacionalListaService(identificador);
        console.log(data);
        setEstruturaOrganizacional(data.data);
      };
      fetchEstruturaOrganizacional();
    }
  }, [identificador]);

  return (
    <CollapsibleList
      items={estruturaOrganizacional}
      titleField="nome"
      contentField="texto"
      showQuestionIcon={false}
      sortByField="ordemExibicao"
    />
  );
}
